import {
  StyleSheet,
  Text,
  View,
  FlatList,
  TouchableOpacity,
  Image,
} from "react-native";
import React from "react";
import { categoriesList } from "./categories";
import { useNavigation } from "@react-navigation/native";
import { HomeScreenProps } from "../../screens/HomeStack/HomeStack";

const DiscountsPerCategoryCard = ({ title }: { title: string }) => {
  const navigation = useNavigation<HomeScreenProps["navigation"]>();
  const titleArray = title.split(" ");
  return (
    <View style={styles.root}>
      <Text style={styles.title}>
        {titleArray[0] + " " + titleArray[1]}{" "}
        <Text style={styles.bold}>{titleArray[2]}</Text>
      </Text>
      <FlatList
        data={categoriesList}
        contentContainerStyle={styles.flatListContainer}
        horizontal
        renderItem={({ item }) => {
          return (
            <TouchableOpacity
              style={styles.category}
              onPress={() =>
                navigation.navigate("Discounts", {
                  screen: "Specific",
                  params: { category: item.category },
                })
              }
            >
              <Image source={item.imgSrc} style={styles.image} />
              <Text style={styles.categoryTitle}>{item.category}</Text>
            </TouchableOpacity>
          );
        }}
      />
    </View>
  );
};

export default DiscountsPerCategoryCard;

const styles = StyleSheet.create({
  root: {
    width: "90%",
    marginHorizontal: "5%",
    height: 200,
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    borderRadius: 17,
    paddingTop: 18,
    marginBottom: 30,
  },
  title: { marginLeft: 18, fontSize: 16 },
  bold: { fontWeight: "bold" },
  category: {
    width: 96,
    height: 134,
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.29,
    shadowRadius: 4.65,

    elevation: 7,
    borderRadius: 17,
    marginRight: 8,
    marginTop:12,
    alignItems: "center",
  },
  flatListContainer: {
    paddingLeft: "5%",
    paddingRight: 5,
  },
  image: {
    width: 64,
    height: 64,
    backgroundColor: "#f5f5f5",
    borderRadius: 32,
    margin: 16,
  },
  categoryTitle: {
    fontSize: 13,
    fontWeight: "500",
    textAlign: "center",
  },
});
